import React from 'react';

interface Props {
  title: string;
  text: string;
  conditionalClasses?: string;
}

export default function AcquisitionOption({
  title,
  text,
  conditionalClasses
}: Props) {
  return (
    <div
      data-qa={`${title.toLowerCase().split(' ').join('-')}-option`}
      data-testid={`${title.toLowerCase().split(' ').join('-')}-option`}
      className={`text-center before:content-[''] s:w-full s:max-m:relative s:max-m:pt-32 s:max-m:before:absolute s:max-m:before:left-0 s:max-m:before:right-0 s:max-m:before:top-0 s:max-m:before:m-auto s:max-m:before:h-[1px] s:max-m:before:w-[100px] s:max-m:before:bg-grey-2 s:max-m:first:pb-32 s:max-s:whitespace-nowrap m:w-1/2 m:px-20 ${conditionalClasses}`}
    >
      <p className="m-0 uppercase text-blue-6 tl-header-m">{title}</p>
      <p className="m-0 mt-8 text-grey-5 tl-body-s">{text}</p>
    </div>
  );
}
